/**
 * @version
 * 4.70.0 OAUI-678 Build "Driver Assignment" UI
 * 4.68.0 DEVOPS-928 Add environment route resolver to all Angular repos
 * 4.67.0 OAUI-660 The order-admin-ui redirects to order-admin-ui root before directing to the target URL
 * 4.64.0 OAUI-646 Upgrades for Angular v16
 * 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 *
 * @author Jenny Lam <jlam@buildcentrix.com>
 * @author Ryan Sweeney <rsweenet@buildcentrix.com>
 *
 * @copyright (c) 2023-2024 Build Centrix
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

@NgModule({
  declarations: [],
  exports: [RouterModule],
  imports: [
    RouterModule.forRoot(
      [
        { path: '', redirectTo: 'orders', pathMatch: 'full' },
        {
          path: 'errors',
          loadChildren: () =>
            import(`./pages/errors/components/errors.module`).then(
              (m) => m.ErrorsModule,
            ),
        },
        {
          path: 'orders',
          canActivate: [AuthGuard],
          loadChildren: () =>
            import(`./pages/orders/orders.module`).then((m) => m.OrdersModule),
        },
        {
          path: 'modelViewer',
          canActivate: [AuthGuard],
          loadChildren: () =>
            import(`./pages/modelViewer/model-viewer.module`).then(
              (m) => m.ModelViewerModule,
            ),
        },
        {
          path: 'shipping',
          canActivate: [AuthGuard],
          loadChildren: () =>
            import(`./pages/shipping/shipping.module`).then(
              (m) => m.ShippingModule,
            ),
        },
        { path: '**', redirectTo: 'orders' },
      ],
      {},
    ),
  ],
})
export class AppRoutingModule {}

// EOF
